import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const changeLanguage = createAction(Constants.CHANGE_LANGUAGE.REQUEST, params => params);
